export default __webpack_public_path__ + "static/img_wave_02-a7e48cb615afadff80cb0375c5d55d08.png";